<template>
  <StackLayout class="foot">
    <AgButtonSet class="links" flexWrap="wrap">
      <template v-for="(route, index) in routes">
        <AgButton flat link :key="index" :text="route.meta.title" :icon="route.meta.icon" :action="!!route.url ? 'externalLink' : 'chevronRight'" @tap="handle(route)" @click="handle(route)" />
      </template>
    </AgButtonSet>
  </StackLayout>
</template>

<script>

import env from '@/helpers/env'
import url from '@/helpers/url'
import routes from '@/helpers/routes'
import capacitor from '@/helpers/capacitor'
import dialog from '@/helpers/dialog'
import AgModalNext from '@/components/Modal/Next'

export default {
  computed: {
    routes () {
      if (this.$store.getters['user/isSoftLogin']) {
        return [
          routes.external.websiteContact,
          routes.external.websiteImprint,
          routes.external.websiteDataProtection,
        ]
      }
      if (env.isWeb && !capacitor.check()) {
        return [
          routes.external.websiteContact,
          routes.external.website,
          routes.external.referral,
          routes.external.websiteImprint,
          {
            meta: {
              title: 'Nutzungsbedingungen',
              icon: 'agila:contract'
            },
            path: '/page/terms-and-conditions'
          },
          routes.external.websiteDataProtection,
          routes.external.websiteComplaintManagement,
          routes.external.websiteDisclaimer,
          // routes.internal.consent
        ]
      } else {
        return [
          routes.external.websiteContact,
          routes.external.website,
          routes.external.referral,
        ]
      }
    }
  },
  methods: {
    handle (route) {
      if (typeof route.action === 'function') {
        route.action()
      } else if (route.modal === true) {
        this.openWebViewDialog(route.meta.title, route.url)
      } else if (typeof route.url === 'string') {
        url.open(route.url)
      } else {
        this.$router.push(route)
      }
    },
    openWebViewDialog (title, path) {
      dialog.component(AgModalNext, { title, path, externalUrl:true }, true, null, true)
    },
  }
}

</script>

<style scoped lang="scss">

.ns-ios,
.ns-android {
  .links {
    padding: 40 0 70 0;
  }
}

html {
  .links {
    padding: 40px 0 70px 0;
  }
}

</style>